import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// users — Single user table (merged platform_users + tenant users)
// ============================================================================
export const users = sqliteTable("core_users", {
  id: text("id").primaryKey(), // ULID
  email: text("email").notNull().unique(),
  name: text("name").notNull(),
  passwordHash: text("password_hash").notNull(),
  avatarUrl: text("avatar_url"),
  tenantId: text("tenant_id"), // FK → tenants (1 user = 1 tenant)
  isPlatformAdmin: integer("is_platform_admin").notNull().default(0),
  isActive: integer("is_active").notNull().default(1),
  lastLoginAt: text("last_login_at"),
  resetToken: text("reset_token"),
  resetTokenExpiresAt: text("reset_token_expires_at"),
  preferences: text("preferences"), // JSON string — notification preferences
  defaultBranchId: text("default_branch_id"), // สาขาเริ่มต้น
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

// Type exports
export type User = typeof users.$inferSelect;
export type NewUser = typeof users.$inferInsert;
